import { meAAAGQL, Query } from "@onmo/graphql/graphql";
import { selectIsAuthenticated } from "@onmo/auth";
import { useAppSelector } from "../components/hooks";
import { useQuery } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export const useSentryUser = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { data } = useQuery<{ me: Query["me"] }>(meAAAGQL, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (isAuthenticated && data?.me) {
      Sentry.setUser({
        id: data.me.id,
        username: data.me.username,
        email: data.me.email ?? undefined,
        phone: data.me.phone ?? undefined,
      });
      Sentry.setTag("tenant", data.me.tenantId ?? "unknown");
    } else if (!isAuthenticated) {
      Sentry.setUser(null);
    }
  }, [isAuthenticated, data]);
};
